import React, { Component } from 'react';
import {
  Stack,
  Box,
  InputAdornment,
  Typography,
  Autocomplete,
  TextField,
  Button,
} from '@mui/material';
import { AppConfigs } from '../SetUp/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

class SearchAppsAutocomplete extends Component {
  state = {
    searchText: '',
    selectedApp: null,
    options: [],
  };

  componentDidMount() {
    this.setState({
      options: AppConfigs.Apps.filter((app) => !app.isDeleted)
        .sort((appA, appB) => appA.name.localeCompare(appB.name))
        .map((app) => ({
          ...app,
          label: app.name,
        })),
    });
  }

  getOptionLabel = (option) => {
    return typeof option === 'string' ? option : option?.name || '';
  };

  filterOptions = (options, state) => {
    const searchText = state.inputValue.toLowerCase();

    return options.filter((option) => {
      return `${option.name} ${option.desc}`.toLowerCase().includes(searchText);
    });
  };

  onTextChange = (e, text, reason) => {
    this.setState((prevState) => ({
      searchText: text,
      selectedApp:
        (reason === 'input' || reason === 'clear') &&
        prevState.selectedApp &&
        text !== prevState.selectedApp.name
          ? null
          : prevState.selectedApp,
    }));
  };

  onAppChange = (e, app) => {
    this.setState({
      searchText: app?.name || '',
      selectedApp: app || null,
    });

    if (this.props.saveApplicationsFilter) {
      this.props.saveApplicationsFilter(app ?? '');
    }
  };

  onGoToApp = () => {
    if (this.state.selectedApp?.link) {
      window.open(this.state.selectedApp.link, '_blank', 'noopener,noreferrer');
    }
  };

  onFocus = () => {
    if (this.props.toggleFocus && !this.props.isSearchOnFocus) {
      this.props.toggleFocus();
    }
  };

  onBlur = (event) => {
    if (
      this.props.toggleFocus &&
      this.props.isSearchOnFocus &&
      !event.currentTarget.contains(event.relatedTarget)
    ) {
      this.props.toggleFocus();
    }
  };

  render() {
    const imgPath = '/img/logos/';
    const autocompleteOpen =
      this.props.isSearchOnFocus === undefined
        ? undefined
        : Boolean(this.props.isSearchOnFocus && this.state.searchText && !this.state.selectedApp);
    const canGoToApp = Boolean(this.state.selectedApp?.link);

    return (
      <Stack
        direction="row"
        spacing={1}
        alignItems="stretch"
        className={
          'myOdu__searchAppsAutocompleteWrapper ' +
          (this.props.isTopNav ? 'topNav ' : '') +
          (this.props.isSearchOnFocus ? 'onFocus' : '')
        }
      >
        <Autocomplete
          className={
            'myOdu__hideFloatLabel myOdu__searchAppsAutocomplete ' +
            (this.props.isTopNav ? 'topNav ' : '') +
            ' ' +
            (this.props.isMobile ? 'mobile ' : '') +
            ' ' +
            (this.props.isSearchOnFocus ? ' onFocus' : '')
          }
          disablePortal
          selectOnFocus
          handleHomeEndKeys
          blurOnSelect={false}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          options={this.state.options}
          forcePopupIcon={false}
          getOptionLabel={this.getOptionLabel}
          filterOptions={this.filterOptions}
          inputValue={this.props.searchText ?? this.state.searchText}
          onInputChange={this.onTextChange}
          value={this.props.text ?? this.state.selectedApp}
          onChange={this.onAppChange}
          open={autocompleteOpen}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              label="Choose app..."
              placeholder="Choose app..."
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment className="cursor-pointer" position="end">
                    {/* <InputAdornment className="cursor-pointer" position="end" onClick={this.props.toggleOpen}> */}
                    {/* <FontAwesomeIcon icon={this.props.isTopNav ? faXmark : faMagnifyingGlass} /> */}
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </InputAdornment>
                ),
              }}
            />
          )}
          renderOption={(optionProps, option, state) => {
            const { key, ...listItemProps } = optionProps;
            const nameMatches = match(option.name, state.inputValue, {
              insideWords: true,
            });
            const nameParts = parse(option.name, nameMatches);

            const descMatches = match(option.desc, state.inputValue, {
              insideWords: true,
            });
            const descParts = parse(option.desc, descMatches);

            return (
              <li key={key} {...listItemProps}>
                <Box className="w-100">
                  <Stack direction="row" alignItems="center">
                    <Box className="myOdu__logoZoom myOdu__searchAppsAutocompleteOptionLogo">
                      <img src={imgPath + option.icon} alt="" role="presentation" />
                    </Box>
                    <Stack>
                      {/* App Name */}
                      <Typography component="div">
                        <div>
                          {nameParts.map((part, index) => (
                            <span
                              key={index}
                              className={
                                part.highlight ? 'myOdu__searchAppsAutocompleteMatch' : undefined
                              }
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </Typography>
                      {/* App Description */}
                      <Typography
                        component="div"
                        variant="smaller"
                        className="myOdu__searchAppsAutocompleteOptionDesc"
                      >
                        <div>
                          {descParts.map((part, index) => (
                            <span
                              key={index}
                              className={
                                part.highlight ? 'myOdu__searchAppsAutocompleteMatch' : undefined
                              }
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </li>
            );
          }}
        />
        <Button
          variant="outlined"
          size="small"
          disabled={!canGoToApp}
          onClick={this.onGoToApp}
          className="myOdu__button secondary myOdu__searchAppsAutocompleteButton"
          aria-label="Open selected application in new tab"
        >
          Open App
        </Button>
      </Stack>
    );
  }
}

// const mapStateToProps = (state) => {
//     return {
//         text: state.applicationsReducer.text
//     }
//   }

// const mapDispatchToProps = (dispatch) => ({
//     saveApplicationsFilter: (text) => dispatch(saveApplicationsFilter(text))
// });

// export default connect(mapStateToProps, mapDispatchToProps)(Head);

export default SearchAppsAutocomplete;
